/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faQuestionCircle} from '@fortawesome/pro-solid-svg-icons';

const HelpIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faQuestionCircle} {...props} />
);

export default HelpIcon;
